import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { poolsApi } from '@/api/pools'

export const usePoolStore = defineStore('pool', () => {
  const pools = ref([])
  const currentPool = ref(null)

  const phase = computed(() => currentPool.value?.phase)
  const isPreparation = computed(() => phase.value === 'PREPARATION')
  const isPurchasing = computed(() => phase.value === 'PURCHASING')
  const isManagement = computed(() => phase.value === 'MANAGEMENT')

  async function loadPools() {
    const res = await poolsApi.list()
    pools.value = res.data
  }

  async function selectPool(id) {
    const res = await poolsApi.get(id)
    currentPool.value = res.data
  }

  async function refreshCurrentPool() {
    if (currentPool.value) {
      const res = await poolsApi.get(currentPool.value.id)
      currentPool.value = res.data
    }
  }

  return { pools, currentPool, phase, isPreparation, isPurchasing, isManagement,
           loadPools, selectPool, refreshCurrentPool }
})
